// The catalog controller owns card content and its registry. This renderer owns
// group markup and placement, including groups adopted from the published page.
function placeChildren(parent, children) {
  const wanted = new Set(children);
  for (const child of Array.from(parent.children)) {
    if (!wanted.has(child)) parent.removeChild(child);
  }
  children.forEach((child, index) => {
    const current = parent.children[index] || null;
    if (current !== child) parent.insertBefore(child, current);
  });
}

function createGroup(createElement, key) {
  const section = createElement(
    "fieldset",
    "fishydex-group fieldset card card-border bg-base-100 [content-visibility:auto] [contain-intrinsic-block-size:auto_120rem]",
  );
  section.dataset.fishydexGroupKey = key;
  const legend = createElement("legend", "fishydex-group-title fieldset-legend ml-6 px-2");
  const body = createElement("div", "card-body pt-0");
  const header = createElement("div", "fishydex-group-header");
  header.appendChild(createElement("span", "fishydex-group-count badge badge-ghost"));
  body.append(header, createElement("div", "fishydex-card-grid"));
  section.append(legend, body);
  return section;
}

export function reconcileFishydexCatalog({
  grid, groups, cards, itemId, createElement, renderCard, renderEmpty,
}) {
  const existingGroups = new Map(Array.from(grid.children, (section) => [
    section.dataset.fishydexGroupKey, section,
  ]));
  const visibleIds = new Set();
  const sections = [];
  let addedIndex = 0;
  // Retained cards must not replay their entrance if sorting or regrouping moves
  // them. Cards that stay in place never leave their original parent.
  for (const card of cards.values()) card.classList.remove("is-entering");
  for (const group of groups) {
    if (!group.entries.length) continue;
    const section = existingGroups.get(group.key) || createGroup(createElement, group.key);
    const legend = section.querySelector(".fishydex-group-title");
    const count = section.querySelector(".fishydex-group-count");
    if (legend.textContent !== group.label) legend.textContent = group.label;
    if (count.textContent !== group.countLabel) count.textContent = group.countLabel;
    const children = group.entries.map((entry) => {
      const id = itemId(entry);
      visibleIds.add(id);
      return cards.get(id) || renderCard(entry, addedIndex++);
    });
    placeChildren(section.querySelector(".fishydex-card-grid"), children);
    sections.push(section);
  }
  if (!sections.length && renderEmpty) sections.push(renderEmpty());
  placeChildren(grid, sections);
  for (const id of cards.keys()) {
    if (!visibleIds.has(id)) cards.delete(id);
  }
}
